import { useCallback, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { PlayerStatsInterface } from '../models/PlayerStats';
import { PlayerCard, PlayerName } from './styles/TigersPlayerCard.Styles';


const formatPlayerName = (fullName: string, isMobile: boolean, number: number): string => {
    const names = fullName.split(' ');
    if (isMobile) {
      return names[names.length - 1];
    }
    // Keep only first and last name
    if (names.length > 2) {
      return `${names[0]} ${names[names.length - 1]}`;
    }
    return fullName;
};

interface ImageErrorState {
    [key: string]: boolean;
} 

export const TigersPlayerCard = (props: { player: PlayerStatsInterface, isMobile: boolean }) => {
    const navigate = useNavigate();
    const [imageErrors, setImageErrors] = useState<ImageErrorState>({});
    const handlePlayerClick = (playerName: string) => {
        navigate(`/player/${encodeURIComponent(playerName)}`);
    };
    const handleImageError = useCallback((playerName: string) => {
        setImageErrors(prev => {
            if (prev[playerName]) return prev;
            return { ...prev, [playerName]: true };
        });
        }, []);

    return (<PlayerCard key={props.player.player}>
    <div className="player-header">
      <img 
        src={imageErrors[props.player.player] 
          ? '/images/players/placeholder-player.jpg'
          : `/images/players/${props.player.player.replace(/\s+/g, '-')}.png`
        }
        alt={props.player.player}
        onError={() => handleImageError(props.player.player)}
      />
      <div className="player-info">
        <PlayerName onClick={() => handlePlayerClick(props.player.player)}>
          {formatPlayerName(props.player.player, props.isMobile, props.player.number)}
          <span className="player-number">#{props.player.number || '0'}</span>
        </PlayerName>
        <div className="position">{props.player.position}</div>
      </div>
    </div>
    
    <div className="stat">
      <div className="value">{props.player.gamesPlayed}</div>
      <div className="label">Games</div>
    </div>
    
    <div className="stat">
      <div className="value">{props.player.goals}</div>
      <div className="label">Goals</div>
    </div>
    
    <div className="stat">
      <div className="value">{props.player.assists}</div>
      <div className="label">Assists</div>
    </div>
    
    <div className="stat">
      <div className="value">{props.player.points}</div>
      <div className="label">Points</div>
    </div>

    <div className="stat">
      <div className="value">{props.player.ppg.toFixed(2)}</div>
      <div className="label">PPG</div>
    </div>

    <div className="stat">
      <div className="value">{props.player.pims}</div>
      <div className="label">PIMS</div>
    </div>
  </PlayerCard>)
};